import { render, staticRenderFns } from "./MobileFieldCard.vue?vue&type=template&id=323383fc&scoped=true"
import script from "./MobileFieldCard.vue?vue&type=script&lang=js"
export * from "./MobileFieldCard.vue?vue&type=script&lang=js"
import style0 from "./MobileFieldCard.vue?vue&type=style&index=0&id=323383fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323383fc",
  null
  
)

export default component.exports